import { BRAND_DETAILS_ACTION } from "core/constants/Actions";
import { TypedThunk, TypedDispatch } from "App/Store";
import { getBrandById } from "core/services/Brand";

export function getBrand(brandId: string | number): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: BRAND_DETAILS_ACTION.REQUEST });
    const apiResponse = await getBrandById(brandId);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRAND_DETAILS_ACTION.SUCCESS,
        payload: { brand: apiResponse.data.brand },
      });
    } else {
      dispatch({ type: BRAND_DETAILS_ACTION.FAILURE });
    }
  };
}

export function resetBrandDetails() {
  return { type: BRAND_DETAILS_ACTION.RESET };
}
